import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  operation: 'executeQuery',
  warehouseId: '',
  statement: '',
  statementId: '',
  waitTimeout: '30s',
  rowLimit: 10000,
  byteLimitMb: 10,
  parameters: { values: [] },
  // Settings tab
  catalog: '',
  schema: '',
  disposition: 'INLINE',
  format: 'JSON_ARRAY',
  continueOnFail: false,
};

export default defaults;
